import React from "react";
import Home from "./Pages/Home/Home";

export default function Application() {
    return (
        <>
            <Home />
        </>
    );
}